import { message, Row, Col, Alert } from "antd";
import React, { Component } from "react";
import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import { Form, FormItem, InputNumberItem, DatePickerItem, CheckItem, ErrorItem } from "../../../../Components/Items";
import ModalItem from "../../../../Components/ModalItem";
import SelectProyectosItem from "../../../../Components/SelectProyectosItem";

const MATRICES_TEMPLATE = "8% 62% 30%";

class ModalGenerarOrdenesProduccion extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    errores: [],
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.visible && this.props.visible) {
      this.setState({ errores: [] });
      this.formRef.current?.setFieldsValue({
        fechaInicio: moment().startOf("hour").add(1, "hour"),
        matrices: (this.props.matrices || []).map((matriz) => ({
          incluir: true,
          matrizId: matriz.matrizId,
          etiqueta: [matriz.clave, matriz.descripcion].filter(Boolean).join(" - "),
          cantidad: matriz.piezas,
        })),
      });
    }
  }

  cerrar(generadas) {
    this.formRef.current?.resetFields();
    this.props.onCerrar(generadas);
  }

  onFinish(values) {
    const matrices = (this.formRef.current?.getFieldsValue(true)?.matrices || [])
      .filter((matriz) => matriz.incluir && matriz.cantidad > 0)
      .map((matriz) => ({ matrizId: matriz.matrizId, cantidad: matriz.cantidad }));
    if (matrices.length === 0) {
      message.warning("Elige al menos una matriz con cantidad mayor a 0");
      return;
    }

    this.setState({ loading: true, errores: [] });
    axios
      .post(
        "preCotizacionIngenieria/generarOrdenesProduccion",
        {
          empresaId: this.props.empresaId,
          preCotizacionId: this.props.preCotizacionId,
          proyectoEjecucionId: values.proyectoEjecucionId,
          fechaInicio: values.fechaInicio,
          matrices,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        const generadas = res.data.generadas || [];
        const errores = res.data.errores || [];
        if (generadas.length > 0) {
          message.success(`Se generaron ${generadas.length} orden(es): ${generadas.map((g) => g.folio).join(", ")}`);
        }
        if (errores.length > 0) {
          this.setState({ errores });
          return;
        }
        if (res.data.success === 2) {
          this.cerrar(generadas);
        } else {
          message.error(res.data.message || "No se pudieron generar las órdenes");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("No se pudieron generar las órdenes");
      });
  }

  render() {
    const tipoOrden = this.props.ordenesMaquila ? "maquila" : "producción";
    const etiquetaPorMatriz = new Map(
      (this.props.matrices || []).map((matriz) => [String(matriz.matrizId), [matriz.clave, matriz.descripcion].filter(Boolean).join(" - ")])
    );

    return (
      <ModalItem
        title={`Generar órdenes de ${tipoOrden}`}
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={() => this.cerrar(this.state.errores.length > 0 ? [] : undefined)}
        onOk={() => this.formRef.current?.submit()}
        okText="Generar"
        confirmLoading={this.state.loading}
        footer
        width="55%"
        paddingTop
      >
        <Form
          ref={this.formRef}
          name="ModalGenerarOrdenesProduccion"
          layoutForm="vertical"
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={ErrorItem}
        >
          <Row gutter={16}>
            <Col xs={24} md={14}>
              <FormItem
                label="Proyecto de ejecución"
                name="proyectoEjecucionId"
                required
                margin
                tooltip="Dónde se consume el material y se produce. De aquí salen las requisiciones."
              >
                <SelectProyectosItem empresaId={this.props.empresaId} headersToken={this.props.headersToken} placeholder="Proyecto" />
              </FormItem>
            </Col>
            <Col xs={24} md={10}>
              <FormItem label="Fecha y hora de inicio" name="fechaInicio" required margin>
                <DatePickerItem
                  style={{ width: "100%" }}
                  allowClear={false}
                  placeholder="Fecha y hora"
                  showTime={{ format: "HH:mm", minuteStep: 5 }}
                  format="DD/MM/YYYY HH:mm"
                />
              </FormItem>
            </Col>
          </Row>

          <div style={{ border: "1px solid #f0f0f0", borderRadius: 8, overflow: "hidden", marginBottom: 10 }}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: MATRICES_TEMPLATE,
                gap: 6,
                padding: "8px 10px",
                background: "#fafafa",
                borderBottom: "1px solid #e8e8e8",
                fontSize: 12,
                fontWeight: 600,
                color: "#595959",
              }}
            >
              <span />
              <span>Matriz (una orden por matriz)</span>
              <span>Piezas a producir</span>
            </div>
            <Form.List name="matrices">
              {(fields) =>
                fields.map(({ key, name, ...restField }, indice) => (
                  <div
                    key={key}
                    style={{
                      display: "grid",
                      gridTemplateColumns: MATRICES_TEMPLATE,
                      gap: 6,
                      alignItems: "center",
                      padding: "5px 10px",
                      borderBottom: "1px solid #f5f5f5",
                      background: indice % 2 === 1 ? "#fcfcfc" : "white",
                    }}
                  >
                    <FormItem {...restField} name={[name, "incluir"]} valuePropName="checked" noStyle>
                      <CheckItem />
                    </FormItem>
                    <FormItem noStyle shouldUpdate>
                      {({ getFieldValue }) => <span>{getFieldValue(["matrices", name, "etiqueta"])}</span>}
                    </FormItem>
                    <FormItem {...restField} name={[name, "cantidad"]} noStyle>
                      <InputNumberItem min={0} style={{ width: "100%" }} />
                    </FormItem>
                  </div>
                ))
              }
            </Form.List>
          </div>

          {this.state.errores.length > 0 && (
            <Alert
              type="error"
              showIcon
              message="Algunas órdenes no se generaron"
              description={this.state.errores.map((error) => (
                <div key={String(error.matrizId)}>
                  <b>{etiquetaPorMatriz.get(String(error.matrizId)) || "Matriz"}:</b> {error.error}
                </div>
              ))}
            />
          )}
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  ordenesMaquila: state.empresa.ordenesMaquila,
});

export default connect(mapStateToProps)(ModalGenerarOrdenesProduccion);
